import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import { Helmet } from 'react-helmet';
import "./InsightPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { Link } from 'react-router-dom';
import {InSights} from "../../data";

function App() {
  return <X06InsightsPageDesktop {...x06InsightsPageDesktopData} />;
}

export default App;

function X06InsightsPageDesktop(props) {
  const {
    insights,
    rectangle85,
    text83,
    text832,
    text833,
    text834,
    text835,
    text836,
    //headerWithBackgroundProps,
    insightsCard82Props,
    insightsCard92Props,
    insightsCard102Props,
    insightsCard112Props,
    insightsCard82Props2,
    insightsCard92Props2,
    insightsCard102Props2,
    insightsCard112Props2,
    //footer32Props,
  } = props;

  return (
    <div className="ipd-container-center-horizontal">
      <Helmet>
        <title>Webuildd Construction | Insights </title>
        <meta name="keywords" content="house builders in Bangalore, Architecture firms in Bangalore, Vastu tips for house construction, Vastu for House Construction, construction cost in Bangalore, house construction cost in Bangalore, super built-up area, BBMP byelaws, budget for your house construction, construction cost in Bangalore, borewell cost in Bangalore, borewell application form, bbmp plan approval, bbmp building plan approval rules," />
        <meta name="description" content="Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency." />
      </Helmet>
      <div className="ipd-x06-insights-page-desktop ipd-screen">
        {/* <HeaderWithBackground {...headerWithBackgroundProps} /> */}
        <NavBar />
        <div className="ipd-frame-1570">
          <h1 className="ipd-title ipd-valign-text-middle ipd-typographyheadlineh2-extrabold-40">{insights}</h1>
          {/* <img className="ipd-rectangle-85" src={rectangle85} /> */}
          <img className="ipd-rectangle-85" src={InSights.InsightsHeader} alt="Webuildd Insights"/>
          <div className="ipd-text-28 ipd-typographybody16-regular">
          <p>{text83}</p>
          <p>{text832}</p>
          <p>{text833}</p>
          <p>{text834}</p>
          <p>{text835}</p>
          <p>{text836}</p>
          </div>
          <div className="ipd-flex-row">
            <InsightsCard82
              x1600I26012676202={insightsCard82Props.x1600I26012676202}
              text37={insightsCard82Props.text37}
              button8Props={insightsCard82Props.button8Props}
            />
            <InsightsCard92
              x1600I26012677202={insightsCard92Props.x1600I26012677202}
              propertyTaxI26012={insightsCard92Props.propertyTaxI26012}
              button8Props={insightsCard92Props.button8Props}
            />
            <InsightsCard102
              x1600I26012678202={insightsCard102Props.x1600I26012678202}
              propertyTaxI26012={insightsCard102Props.propertyTaxI26012}
              button8Props={insightsCard102Props.button8Props}
            />
            <InsightsCard112
              x1600I26012679202={insightsCard112Props.x1600I26012679202}
              propertyTaxI26012={insightsCard112Props.propertyTaxI26012}
              button8Props={insightsCard112Props.button8Props}
            />
          </div>
          <div className="ipd-flex-row-1">
            <InsightsCard122
              x1600I26012680202={insightsCard82Props2.x1600I26012680202}
              propertyTaxI26012={insightsCard82Props2.propertyTaxI26012}
              button8Props={insightsCard82Props2.button8Props}
            />
            <InsightsCard132
              x1600I26012681202={insightsCard92Props2.x1600I26012681202}
              propertyTaxI26012={insightsCard92Props2.propertyTaxI26012}
              button8Props={insightsCard92Props2.button8Props}
            />
            <InsightsCard142
              x1600I26012682202={insightsCard102Props2.x1600I26012682202}
              propertyTaxI26012={insightsCard102Props2.propertyTaxI26012}
              button8Props={insightsCard102Props2.button8Props}
            />
            <InsightsCard152
              x1600I26012682202={insightsCard112Props2.x1600I26012682202}
              propertyTaxI26012={insightsCard112Props2.propertyTaxI26012}
              button8Props={insightsCard112Props2.button8Props}
            />
          </div>
          <Footer />
          {/* <Footer32 {...footer32Props} /> */}
        </div>
      </div>
    </div>
  );
}


// function HeaderWithBackground(props) {
//   const {
//     unselectedI2601268,
//     unselectedI26012682,
//     unselectedI26012683,
//     unselectedI26012684,
//     text38,
//     unselectedI26012685,
//     unselectedI26012686,
//     unselectedI26012687,
//     group86Props,
//     getAQuoteButton22Props,
//   } = props;

//   return (
//     <div className="ipd-header-with-background">
//       <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
//       <div className="ipd-frame-34">
//         <div className="ipd-frame-27">
//             <Link to="/">
//           <div className="ipd-unselected-i2601268 ipd-valign-text-middle ipd-typography-body-smalltext-14-regular">
//             {unselectedI2601268}
//           </div>
//           </Link>
//           <Link to="/about">
//           <div className="ipd-unselected-i2601268-1 ipd-valign-text-middle ipd-typography-body-smalltext-14-regular">
//             {unselectedI26012682}
//           </div>
//           </Link>
//           <Link to="/project">
//           <div className="ipd-unselected-i2601268-2 ipd-valign-text-middle ipd-typography-body-smalltext-14-regular">
//             {unselectedI26012683}
//           </div>
//           </Link>
//           <Link to="/video">
//           <div className="ipd-unselected-i2601268-3 ipd-valign-text-middle ipd-typography-body-smalltext-14-regular">
//             {unselectedI26012684}
//           </div>
//           </Link>
          
//           <div className="ipd-selected">
//             <div className="ipd-overlap-group">
//               <div className="ipd-rectangle-61"></div>
//               {/* <Link to="/insight"> */}
//               <div className="ipd-text-30 ipd-valign-text-middle ipd-overpass-bold-shark-14px">{text38}</div>
//               {/* </Link> */}
//             </div>
//           </div>
//           <Link to="/blog">
//           <div className="ipd-unselected-i2601268-4 ipd-valign-text-middle ipd-typography-body-smalltext-14-regular">
//             {unselectedI26012685}
//           </div>
//           </Link>
//           <Link to="/fag">
//           <div className="ipd-unselected-i2601268-5 ipd-valign-text-middle ipd-typography-body-smalltext-14-regular">
//             {unselectedI26012686}
//           </div>
//           </Link>
//           <Link to="/contactus">
//           <div className="ipd-unselected-i2601268-6 ipd-valign-text-middle ipd-typography-body-smalltext-14-regular">
//             {unselectedI26012687}
//           </div>
//           </Link>
//         </div>
//         <GetAQuoteButton22>{getAQuoteButton22Props.children}</GetAQuoteButton22>
//       </div>
//     </div>
//   );
// }


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="ipd-group-86">
      <White src={whiteProps.src} />
      <img className="ipd-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="ipd-white">
      <img className="ipd-vector" src={src} />
    </div>
  );
}


function GetAQuoteButton22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i2601268464120TimelineData);
  }, []);

  return (
    <div className="ipd-i26012684-64120 ipd-component ipd-component-wrapper not-ready">
      <div className="ipd-master-button-NbXE1V">
        <Link to="/insightdetails">
        <div className="ipd-button-i2601268464-xKG8Jw ipd-valign-text-middle">{children}</div>
      </Link>
      </div>
    </div>
  );
}

const i2601268464120TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".i26012684-64120",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function InsightsCard82(props) {
  const { x1600I26012676202, text37, button8Props } = props;

  return (
    <div className="ipd-insights-card">
      <div className="ipd-group-69">
        <div className="ipd-x1600-i26012676202 ipd-valign-text-middle ipd-typographyheadlineh2-extrabold-40">
          {x1600I26012676202}
        </div>
        <div className="ipd-text-29 ipd-valign-text-middle ipd-typographybodycaption-14-semi-bold">{text37}</div>
      </div>
      <Link to="/insightdetails-bbmp">
      <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function Button8(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i260126762022185TimelineData);
  }, []);

  return (
    <div className="ipd-i26012676-2022185 ipd-component ipd-component-wrapper not-ready">
      <div className="ipd-master-button-xUGtXW">
        <div className="ipd-button-i2601267620-6Xv77l ipd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i260126762022185TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".i26012676-2022185",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function InsightsCard92(props) {
  const { x1600I26012677202, propertyTaxI26012, button8Props } = props;

  return (
    <div className="ipd-insights-card-1">
      <div className="ipd-group-69-1">
        <div className="ipd-x1600-i26012677202 ipd-valign-text-middle ipd-typographyheadlineh2-extrabold-40">
          {x1600I26012677202}
        </div>
        <div className="ipd-property-tax-i26012 ipd-valign-text-middle ipd-typographybodycaption-14-semi-bold">
          {propertyTaxI26012}
        </div>
      </div>
      <Link to="/insightdetails-bwssb">
      <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard102(props) {
  const { x1600I26012678202, propertyTaxI26012, button8Props } = props;

  return (
    <div className="ipd-insights-card-2">
      <div className="ipd-group-69-2">
        <div className="ipd-x1600-i26012678202 ipd-valign-text-middle ipd-typographyheadlineh2-extrabold-40">
          {x1600I26012678202}
        </div>
        <div className="ipd-property-tax-i26012-1 ipd-valign-text-middle ipd-typographybodycaption-14-semi-bold">
          {propertyTaxI26012}
        </div>
      </div>
      <Link to="/insightdetails-bescom">
      <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard112(props) {
  const { x1600I26012679202, propertyTaxI26012, button8Props } = props;

  return (
    <div className="ipd-insights-card-3">
      <div className="ipd-group-69-3">
        <div className="ipd-x1600-i26012679202 ipd-valign-text-middle ipd-typographyheadlineh2-extrabold-40">
          {x1600I26012679202}
        </div>
        <div className="ipd-property-tax-i26012-2 ipd-valign-text-middle ipd-typographybodycaption-14-semi-bold">
          {propertyTaxI26012}
        </div>
      </div>
      <Link to="/insightdetails-procedure">
      <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard122(props) {
  const { x1600I26012680202, propertyTaxI26012, button8Props } = props;

  return (
    <div className="ipd-insights-card-4">
      <div className="ipd-group-69-4">
        <div className="ipd-x1600-i26012680202 ipd-valign-text-middle ipd-typographyheadlineh2-extrabold-40">
          {x1600I26012680202}
        </div>
        <p className="ipd-property-tax-i26012-3 ipd-valign-text-middle ipd-typographybodycaption-14-semi-bold">
          {propertyTaxI26012}
        </p>
      </div>
      <Link to="/insightdetails-vaastu">
      <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard132(props) {
  const { x1600I26012681202, propertyTaxI26012, button8Props } = props;

  return (
    <div className="ipd-insights-card-5">
      <div className="ipd-group-69-5">
        <div className="ipd-x1600-i26012681202 ipd-valign-text-middle ipd-typographyheadlineh2-extrabold-40">
          {x1600I26012681202}
        </div>
        <div className="ipd-property-tax-i26012-4 ipd-valign-text-middle ipd-typographybodycaption-14-semi-bold">
          {propertyTaxI26012}
        </div>
      </div>
      <Link to="/insightdetails-byelaws">
      <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard142(props) {
  const { x1600I26012682202, propertyTaxI26012, button8Props } = props;

  return (
    <div className="ipd-insights-card-6">
      <div className="ipd-group-69-6">
        <div className="ipd-x1600-i26012682202 ipd-valign-text-middle ipd-typographyheadlineh2-extrabold-40">
          {x1600I26012682202}
        </div>
        <div className="ipd-property-tax-i26012-5 ipd-valign-text-middle ipd-typographybodycaption-14-semi-bold">
          {propertyTaxI26012}
        </div>
      </div>
      <Link to="/insightdetails-tips&ideas">
      <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}
function InsightsCard152(props) {
  const { x1600I26012682202, propertyTaxI26012, button8Props } = props;

  return (
    <div className="ipd-insights-card-6">
      <div className="ipd-group-69-6">
        <div className="ipd-x1600-i26012682202 ipd-valign-text-middle ipd-typographyheadlineh2-extrabold-40">
          {x1600I26012682202}
        </div>
        <div className="ipd-property-tax-i26012-5 ipd-valign-text-middle ipd-typographybodycaption-14-semi-bold">
          {propertyTaxI26012}
        </div>
      </div>
      <Link to="/insightdetails-budget">
      <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


// function Footer32(props) {
//   const {
//     overlapGroup1,
//     vector,
//     vector2,
//     group862Props,
//     facebookAppSymbolProps,
//     twitterProps,
//     frame5Props,
//     frame6Props,
//     frame7Props,
//   } = props;

//   return (
//     <div className="ipd-footer">
//       <div className="ipd-frame-1585">
//         <div className="ipd-frame-1578">
//           <Group86222 group85={group862Props.group85} whiteProps={group862Props.whiteProps} />
//           <div className="ipd-frame-1584">
//             <Group324 />
//             <div className="ipd-frame-1583">
//               <FacebookAppSymbol3 src={facebookAppSymbolProps.src} />
//               <div className="ipd-instagram">
//                 <div className="ipd-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="ipd-vector-1" src={vector} />
//                   <img className="ipd-vector-2" src={vector2} />
//                 </div>
//               </div>
//               <Twitter3 src={twitterProps.src} />
//             </div>
//           </div>
//         </div>
//         <Frame53 text40={frame5Props.text40} frame4Props={frame5Props.frame4Props} />
//         <Frame6
//           text48={frame6Props.text48}
//           frame42Props={frame6Props.frame42Props}
//           frame422Props={frame6Props.frame422Props}
//         />
//       </div>
//       <Frame7 text56={frame7Props.text56} frame4Props={frame7Props.frame4Props} />
//     </div>
//   );
// }


function Group86222(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="ipd-group-86-1">
      <White src={whiteProps.src} />
      <img className="ipd-group-85-1" src={group85} />
    </div>
  );
}


function Group324() {
  return (
    <div className="ipd-group-32">
      <div className="ipd-group-189">
        <div className="ipd-map-pin-1">
          <div className="ipd-overlap-group-2">
            <img
              className="ipd-vector-3"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-90@2x.svg"
            />
          </div>
        </div>
        <p className="ipd-text-1 ipd-typographybody16-regular">
          #8, 105, Vishal Park Word, 3rd Cross, Cambridge Road Ulsoor, Bangalore, Bengaluru, Karnataka 560008
        </p>
      </div>
      <div className="ipd-group-18">
        <div className="ipd-phone">
          <img
            className="ipd-vector-4"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg"
          />
        </div>
        <div className="ipd-text ipd-valign-text-middle ipd-typographybody16-regular">+91 8976535221, +91 8755645342</div>
      </div>
      <div className="ipd-group-18">
        <div className="ipd-mail">
          <div className="ipd-overlap-group-3">
            <img
              className="ipd-vector-5"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-93@2x.svg"
            />
          </div>
        </div>
        <div className="ipd-text ipd-valign-text-middle ipd-typographybody16-regular">contact@webuild.com</div>
      </div>
    </div>
  );
}


function FacebookAppSymbol3(props) {
  const { src } = props;

  return (
    <div className="ipd-facebook-app-symbol">
      <img className="ipd-f-1" src={src} />
    </div>
  );
}


function Twitter3(props) {
  const { src } = props;

  return (
    <div className="ipd-twitter">
      <img className="ipd-vector-6" src={src} />
    </div>
  );
}


function Frame53(props) {
  const { text40, frame4Props } = props;

  return (
    <div className="ipd-frame-5">
      <div className="ipd-text-4 ipd-valign-text-middle ipd-typographyheadlineh5-extrabold-20">{text40}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


function Frame4(props) {
  const { text41, text42, text43, text44, text45, text46, text47 } = props;

  return (
    <div className="ipd-frame-4">
        <Link to="/about">
      <div className="ipd-text-2 ipd-valign-text-middle ipd-typographybody16-regular">{text41}</div>
      </Link>
      <div className="ipd-text-3 ipd-valign-text-middle ipd-typographybody16-regular">{text42}</div>
      <div className="ipd-text-3 ipd-valign-text-middle ipd-typographybody16-regular">{text43}</div>
      <div className="ipd-text-3 ipd-valign-text-middle ipd-typographybody16-regular">{text44}</div>
      <Link to="/insight">
      <div className="ipd-text-3 ipd-valign-text-middle ipd-typographybody16-regular">{text45}</div>
      </Link>
      <div className="ipd-text-3 ipd-valign-text-middle ipd-typographybody16-regular">{text46}</div>
      <div className="ipd-text-3 ipd-valign-text-middle ipd-typographybody16-regular">{text47}</div>
    </div>
  );
}


function Frame6(props) {
  const { text48, frame42Props, frame422Props } = props;

  return (
    <div className="ipd-frame-6">
      <div className="ipd-text-12 ipd-valign-text-middle ipd-typographyheadlineh5-extrabold-20">{text48}</div>
      <div className="ipd-frame-1577">
        <Frame42
          text49={frame42Props.text49}
          text50={frame42Props.text50}
          place={frame42Props.place}
          text51={frame42Props.text51}
          text52={frame42Props.text52}
        />
        <Frame42
          text49={frame422Props.text49}
          text50={frame422Props.text50}
          place={frame422Props.place}
          text51={frame422Props.text51}
          text52={frame422Props.text52}
          className={frame422Props.className}
        />
      </div>
    </div>
  );
}


function Frame42(props) {
  const { text49, text50, place, text51, text52, className } = props;

  return (
    <div className={`ipd-frame-4-1 ${className || ""}`}>
      <div className="ipd-text-13 ipd-valign-text-middle ipd-overpass-extra-bold-white-16px">{text49}</div>
      <div className="ipd-frame-1580">
        <div className="ipd-text-1-1 ipd-valign-text-middle ipd-typographybody16-regular">{text50}</div>
        <div className="ipd-place ipd-valign-text-middle ipd-typographybody16-regular">{place}</div>
        <div className="ipd-text-15 ipd-valign-text-middle ipd-typographybody16-regular">{text51}</div>
        <div className="ipd-text-16 ipd-valign-text-middle ipd-typographybody16-regular">{text52}</div>
      </div>
    </div>
  );
}


function Frame7(props) {
  const { text56, frame4Props } = props;

  return (
    <div className="ipd-frame-7">
      <div className="ipd-text-20 ipd-valign-text-middle ipd-typographyheadlineh5-extrabold-20">{text56}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const getAQuoteButton22Data = {
    children: "GET A QUOTE",
};

// const headerWithBackgroundData = {
//     unselectedI2601268: "HOME",
//     unselectedI26012682: "ABOUT US",
//     unselectedI26012683: "PROJECTS",
//     unselectedI26012684: "VIDEOS",
//     text38: "INSIGHTS",
//     unselectedI26012685: "BLOGS",
//     unselectedI26012686: "FAQ’S",
//     unselectedI26012687: "CONTACT US",
//     group86Props: group86Data,
//     getAQuoteButton22Props: getAQuoteButton22Data,
// };

const button8Data = {
    children: "VIEW DETAILS",
};

const insightsCard82Data = {
    x1600I26012676202: "BBMP",
    text37: "Property Tax",
    button8Props: button8Data,
};

const button82Data = {
    children: "VIEW DETAILS",
};

const insightsCard92Data = {
    x1600I26012677202: "BWSSB",
    propertyTaxI26012: "Water Supply",
    button8Props: button82Data,
};

const button83Data = {
    children: "VIEW DETAILS",
};

const insightsCard102Data = {
    x1600I26012678202: "BESCOM",
    propertyTaxI26012: "Electricity Provider",
    button8Props: button83Data,
};

const button84Data = {
    children: "VIEW DETAILS",
};

const insightsCard112Data = {
    x1600I26012679202: "Procedure",
    propertyTaxI26012: "Steps taken for Construction",
    button8Props: button84Data,
};

const button85Data = {
    children: "VIEW DETAILS",
};

const insightsCard122Data = {
    x1600I26012680202: "Vaastu",
    propertyTaxI26012: "Boost positive energy in home",
    button8Props: button85Data,
};

const button86Data = {
    children: "VIEW DETAILS",
};

const insightsCard132Data = {
    x1600I26012681202: "Bye Laws",
    propertyTaxI26012: "Legal Documentation",
    button8Props: button86Data,
};

const button87Data = {
    children: "VIEW DETAILS",
};

const insightsCard142Data = {
    x1600I26012682202: "Tips & Ideas",
    propertyTaxI26012: "Construction Tips & Ideas",
    button8Props: button87Data,
};
const button88Data = {
  children: "VIEW DETAILS",
};

const insightsCard152Data = {
  x1600I26012682202: "Budget",
  propertyTaxI26012: "Construction Budget",
  button8Props: button88Data,
};

const white2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
};

const group86222Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    whiteProps: white2Data,
};

const facebookAppSymbol3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1@2x.svg",
};

const twitter3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-97@2x.svg",
};

const frame4Data = {
    text41: "About Us",
    text42: "Projects",
    text43: "Videos",
    text44: "Packages",
    text45: "Insights",
    text46: "Blogs",
    text47: "FAQ’s",
};

const frame53Data = {
    text40: "Quick Links",
    frame4Props: frame4Data,
};

const frame42Data = {
    text49: "Construction",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
};

const frame422Data = {
    text49: "Interior",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    className: "ipd-frame-5-1",
};

const frame6Data = {
    text48: "Packages",
    frame42Props: frame42Data,
    frame422Props: frame422Data,
};

const frame43Data = {
    text41: "BBEMP",
    text42: "BWSSB",
    text43: "BESCOM",
    text44: "Procedure",
    text45: "Vaastu",
    text46: "Bye Laws",
    text47: "Tips & Ideas",
};

const frame7Data = {
    text56: "Insights",
    frame4Props: frame43Data,
};

// const footer32Data = {
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-94@2x.svg",
//     vector: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-95@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-96@2x.svg",
//     group862Props: group86222Data,
//     facebookAppSymbolProps: facebookAppSymbol3Data,
//     twitterProps: twitter3Data,
//     frame5Props: frame53Data,
//     frame6Props: frame6Data,
//     frame7Props: frame7Data,
// };

const x06InsightsPageDesktopData = {
    insights: "Insights",
    rectangle85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-85-1@1x.png",
    text83: "WeBuildd has been delivering building solutions in Bengaluru and beyond for decades. But you are just getting started to turn your real estate dream into reality. So, let's go over some of the terminology and facts you'll encounter as you begin your journey.",
    text832: "You are probably familiar with the authorities like the Bruhat Bengaluru Mahanagara Palike (BBMP), Bangalore Electricity Supply Company (BESCOM), Bangalore Water Supply and Sewerage Board (BWSSB), but are you aware of the bylaws and regulations that you have to keep in mind when planning your project ?",
    text833: "Moreover, you must be aware of the actual costs of construction in Bengaluru to plan and fix a budget for your project. So, we have the information for you on that as well.",
    text834: "Our steps of construction can be used as a map to start your project. We are sharing these insights to help you plan your journey more effectively.",
    text835: "And don't forget to check out Vastu tips to design your home, as well as for house construction.",
    text836: "So, let's get started...",
    //headerWithBackgroundProps: headerWithBackgroundData,
    insightsCard82Props: insightsCard82Data,
    insightsCard92Props: insightsCard92Data,
    insightsCard102Props: insightsCard102Data,
    insightsCard112Props: insightsCard112Data,
    insightsCard82Props2: insightsCard122Data,
    insightsCard92Props2: insightsCard132Data,
    insightsCard102Props2: insightsCard142Data,
    insightsCard112Props2: insightsCard152Data,

    //footer32Props: footer32Data,
};

